import { CreateFocusCss } from '../../../styles'
import type { Tokens } from '../../../theming/types'
import type { AvatarProps } from '..'

export default (config: {
  props: Pick<AvatarProps, 'border' | 'shape' | 'size'>

  tokens: Tokens
}) => {
  const { props, tokens } = config
  const { border, shape, size } = props

  const avatarRoundPosition = size === 'small' || size === 'xsmall' ? '-2px' : 0
  const avatarSquarePosition = '-4px'

  return {
    default: {
      wrap: {
        display: 'inline-block',
        position: 'relative',

        '& > a': CreateFocusCss(tokens.focusOuter),
      },

      avatar: {
        alignItems: 'center',
        border: border
          ? `${tokens.borderWidthS} solid ${tokens.borderColorEmphasisInverse}`
          : 'none',
        borderRadius: shape === 'square' ? tokens.radiusSizeXS : '50%',
        display: 'inline-flex',
        flexShrink: 0,
        justifyContent: 'center',
        overflow: 'hidden',
        padding: 0,
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: 'box-shadow 0.2s ease',
        verticalAlign: 'middle',
        wordBreak: 'keep-all',
      },

      badge: {
        bottom: shape === 'square' ? avatarSquarePosition : avatarRoundPosition,
        insetInlineEnd:
          shape === 'square' ? avatarSquarePosition : avatarRoundPosition,
        lineHeight: '0px',
        position: 'absolute',
      },

      shadow: {
        boxShadow: tokens.elevationLow,
      },
    },

    image: {
      avatar: {
        img: {
          maxWidth: '100%',
        },
      },
    },

    placeholder: {
      avatar: {
        backgroundColor: tokens.avatarBgColorPlaceholder,

        '& > svg': {
          borderRadius: '50%',
          fill: tokens.fontColorInverse,
          height: '100%',
          overflow: 'hidden',
          width: '100%',
        },
      },
    },
  } as const
}
